import React, { useState, useEffect } from 'react';
import MetricList from './okr_metric_list';
import MetricGraph from './metric_graph';

import { OkrPopUp } from '../../types/okrpopup.types';
import * as OkrPopAction from '../../actions/okr_popup.action';
import KrService from '../../services/kr.service';
import { krdetailActions } from '../../../actions/krDetails.actions';

const service = new KrService();

const OkrMetric = (props: OkrPopUp) => {
    const getGoalMetrics = (p: any = {}) => {
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        service.getGoalMetrics(p)
            .then((response) => {
                removeLoader();
                props.dispatch(OkrPopAction.GetGoalMetric(response.data[0]))
                const selectedMetic = props.goalData.metricId || response.data[0].goals.goal_metrics[0].id;
                // getting dataSource for child mit to show target date
                props.dispatch(krdetailActions.getDataSource(selectedMetic));
                props.dispatch(OkrPopAction.UpdateSelectedMetric({ metricId: selectedMetic }));
            })
            .catch((err: any) => {
                removeLoader();
                console.log('err', err);
            });
    }

    useEffect(() => {
        const params = { goalId: props.goalId, metricId: props.goalData.metricId, json: true };
        getGoalMetrics(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="wb-ghead-metrics">
            <div className="wb-ghead-metrics-wrapper">
                <div className="okr-metric-split">
                    <div className="okr-metric-split__list wb-metric-scrollbar">
                        <MetricList
                            {...props}
                        />
                    </div>
                    <div className="okr-metric-split__chart">
                        <MetricGraph {...props} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OkrMetric;
